const SetNoScrBarVW = () => {
  function setWidth() {
    const widthWithoutScrollbar = document.documentElement.clientWidth;
    document.documentElement.style.setProperty(
      '--vw-noscrbar',
      `${document.documentElement.clientWidth}px`
    );
  }
  window.addEventListener('load', setWidth);
  window.addEventListener('resize', setWidth);
}

export default SetNoScrBarVW;